import { getLocalToken } from './auth';

/**
 * Abstraction of fetch API to handle with authenticated calls
 * https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
 * @param {string} url endpoint URL
 * @param {string} method HTTP method
 * @param {object} headers
 * @param {object} body
 */
export const requestWithAuth = (url, method = 'GET', headers = {}, body = {}) => {
  if (
    !url || typeof url === 'undefined' || !method || !['GET', 'POST', 'UPDATE'].includes(method) || typeof headers !== 'object' || typeof body !== 'object'
  ) {
    throw new TypeError('Incorrect requestWithAuth params', 'requestWithAuth');
  }

  const token = getLocalToken();
  if (!token) {
    throw new Error('Token not found');
  }

  const options = {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...headers,
    },
  };

  if (method === 'POST' && Object.keys(body).length) {
    options.body = JSON.stringify(body);
  }

  return fetch(url, options);
};

export const removeEmptyKeys = (obj) => {
  const newObj = obj;
  Object.keys(newObj).forEach(k => !newObj[k] && newObj[k] !== undefined && delete newObj[k]);
  return newObj;
};

export const objectToQuerystring = (obj) => {
  let delimiter = '';
  let val = '';

  return Object.keys(obj).reduce((str, key, i) => {
    delimiter = i === 0 ? '?' : '&';
    const newKey = encodeURIComponent(key);
    val = encodeURIComponent(obj[newKey]);
    return [str, delimiter, newKey, '=', val].join('');
  }, '');
};

export const flattenMessages = (nestedMessages, prefix = '') => Object.keys(nestedMessages).reduce((messages, key) => {
  const localMessages = messages;
  const value = nestedMessages[key];
  const prefixedKey = prefix ? `${prefix}.${key}` : key;

  if (typeof value === 'string') {
    localMessages[prefixedKey] = value;
  } else {
    Object.assign(localMessages, flattenMessages(value, prefixedKey));
  }

  return localMessages;
}, {});

export const hasErrors = fieldsError => Object.keys(fieldsError).some(field => fieldsError[field]);

export const getUIStatus = (status) => {
  switch (status) {
    case 'Done':
      return 'success';
    case 'Failed':
      return 'error';
    case 'Queued':
      return 'processing';
    default:
      return 'default';
  }
};

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 * @param {function} func
 * @param {timer} wait
 */
export function debounce(fn, delay) {
  let timer = null;
  return (...args) => {
    const context = this;
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(context, args);
    }, delay);
  };
}

export const deepEqual = (x, y) => (x && y && typeof x === 'object' && typeof y === 'object' ? Object.keys(x).length === Object.keys(y).length && Object.keys(x).reduce((isEqual, key) => isEqual && deepEqual(x[key], y[key]), true)
  : x === y);

// I had to separate this function in order to mock this function on tests
export const getStoreState = state => state;



// WEBPACK FOOTER //
// ./src/helpers/utils.js